<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">
          <router-link v-if="$route.meta.parentPath" :to="$route.meta.parentPath">
            <md-icon>arrow_back_ios</md-icon>
          </router-link>
          <md-icon v-else-if="$route.meta.icon">
            <span v-if="$route.meta.icon !=='vk_icon'">{{ $route.meta.icon }}</span>
            <span v-else><v-k-icon/></span>
          </md-icon>
            <template v-if="$route.params.id" >
                {{ $t('pages.'+$route.name,{id:$route.params.id}) }}
            </template>
            <template v-else>
                {{ $t('pages.'+$route.name) }}
            </template>
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <span class="top-user-link">{{ $store.getters.username }}</span>
          <md-button id="button_logout" class="md-button md-theme-default md-simple md-sm" @click="doLogout()">
              {{$t('logout')}}
            <md-icon>logout</md-icon>
          </md-button>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import VKIcon from "@/components/MailNotify/VKIcon";
export default {
  components: {VKIcon},
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    async doLogout() {
      await this.$store.dispatch('authLogout')
      this.$router.push('/login')
    }
  }
};
</script>

<style>
  .top-user-link {
    padding-top: 0.1rem;
  }
</style>
